import type { Store, StoreState } from 'src/store/types';

export default ({ store }: { store: Store }) => {
  const enableFeature = (state: StoreState, featureName: string) => ({
    features: { ...state.features, [featureName]: true },
  });
  window.enableFeature = store.action(enableFeature);

  const forceAdministrator = () => ({
    forceAdministrator: true,
  });
  window.forceAdministrator = store.action(forceAdministrator);
};
